import getUrl from "../get-domain"
import { 
    humanizeNumber, 
    fixFloatNumber,
    convertCurrency,
    handleTvalRederer, 
    handleClassRederer, 
 } from "../market/functions"
import { showActivity, showAlarm, showAlarmClass, calculate_power_buy } from "../market/common"


const createLink = (filter) => {
    if (window.location.href.includes("http://127.0.0.1:3000")) {
        return `/market/realtime/symbol_list?stockFilter=${filter}`
    } else {
        return getUrl().REACT_APP_MARKET_REALTIME_SYMBOLS_PAGE.replace(/{stockFilter}/g, filter)
    }
}

const config = [
    {
        value: 'زمان',
        sortable: false,
        renderer: (row, stock) => row && <a href={createLink(stock)}>{row.time}</a>
    },
    {
        value: 'ارزش',
        sortable: false,
        renderer: (row, stock) => row.total_tval !== undefined && humanizeNumber(convertCurrency(row.total_tval[stock]))
    },
    {
        value: '5/22',
        sortable: false,
        renderer: (row, stock) => row.tval_5_22 !== undefined  && row.tval_5_22[stock],
        className: (row, stock) => row.tval_5_22 !== undefined && handleTvalRederer(row.tval_5_22[stock]),
    },
    {
        value: '5/60 ',
        sortable: false,
        renderer: (row, stock) => row.tval_5_60 !== undefined && row.tval_5_60[stock],
        className: (row, stock) => row.tval_5_60 !== undefined && handleTvalRederer(row.tval_5_60[stock]),
    },
    {
        value: '22/60',
        sortable: false,
        renderer: (row, stock) => row.tval_22_60 !== undefined && row.tval_22_60[stock],
        className: (row, stock) => row.tval_22_60 !== undefined && handleTvalRederer(row.tval_22_60[stock]),
    },
    {
        value: 'قدرت',
        sortable: false,
        renderer: (row, stock) => row.power_buy !== undefined ? row.power_buy[stock].toFixed(2) : 'x',
        className: (row, stock) => row.power_buy !== undefined && handleClassRederer(row.power_buy, 0)
    },
    {
        value: 'قدرت 5',
        sortable: false,
        renderer: (row, stock) =>  {
            return row && row.per_buy_5 !== undefined && row.per_sell_5 !== undefined ?
                calculate_power_buy(row.per_buy_5[stock], row.per_sell_5[stock]).toFixed(2) :
                'x'
        },
        className: (row, stock) => row.per_buy_5 !== undefined ? handleClassRederer(calculate_power_buy(row.per_buy_5[stock], row.per_sell_5[stock]), 0): ''
    },
    {
        value: 'قدرت 22',
        sortable: false,
        renderer: (row, stock) =>  {
            return row && row.per_buy_22 !== undefined && row.per_sell_22 !== undefined ?
                calculate_power_buy(row.per_buy_22[stock], row.per_sell_22[stock]).toFixed(2) :
                'x'
        },
        className: (row, stock) => row.per_buy_22 !== undefined ? handleClassRederer(calculate_power_buy(row.per_buy_22[stock], row.per_sell_22[stock]), 0): ''
    },
    {
        value: 'ورود',
        sortable: false,
        renderer: (row, stock) => row.entry_money !== undefined && row.entry_money !== undefined ? humanizeNumber(convertCurrency(row.entry_money[stock])) : 'x',
        className: (row, stock) => row.entry_money !== undefined ? handleClassRederer(row.entry_money[stock], 0) : '',
    },
    {
        value: 'ورود 5',
        sortable: false,
        renderer: (row, stock) => row.entry_money_avg_5 !== undefined && row.entry_money_avg_5 !== undefined ? humanizeNumber(convertCurrency(row.entry_money_avg_5[stock])) : 'x',
        className: (row, stock) => row.entry_money_avg_5 !== undefined ? handleClassRederer(row.entry_money_avg_5[stock], 0) : '',
    },
    {
        value: 'ورود 22',
        sortable: false,
        className: (row) => row.entry_money_avg_22 !== undefined ? handleClassRederer(row.entry_money_avg_22.stock_rights, 0) : '',
        renderer: (row, stock) => row.entry_money_avg_22 !== undefined && row.entry_money_avg_22 !== undefined ? humanizeNumber(convertCurrency(row.entry_money_avg_22[stock])) : 'x',
    },
    {
        value: 'آخپا',
        sortable: false,
        className: (row) => row.pplc !== undefined ? handleClassRederer(row.pplc.stock_rights, 0) : '',
        renderer: (row, stock) => row.pplc !== undefined && row.pplc !== undefined ? humanizeNumber(row.pplc[stock]) : 'x',
    },
    {
        value: 'آخفرست',
        sortable: false,
        className: (row) => row.pplf !== undefined ? handleClassRederer(row.pplf.stock_rights, 0) : '',
        renderer: (row, stock) => row.pplf !== undefined && row.pplf !== undefined ? humanizeNumber(row.pplf[stock]) : 'x'
    },
    {
        value: 'سایه',
        sortable: false,
        className: (row) => row.pshadow !== undefined ? handleClassRederer(row.pshadow.stock_rights, 0) : '',
        renderer: (row, stock) => row.pshadow !== undefined && row.pshadow !== undefined ? humanizeNumber(row.pshadow[stock]) : 'x'
    },
    {
        value: "هیکن",
        sortable: false,
        className: (row) => row.ch !== undefined && row.oh ? row.ch > row.oh ? 'text-primary' : 'text-danger' : 'x',
        renderer: (row) => row.ch !== undefined && row.oh ? row.ch > row.oh ? 'سبز' : 'قرمز' : 'x',
    },
    {
        value: "اوسیلاتور",
        sortable: false,
        renderer: (row) => row.new_ao !== undefined && row.new_ao,
        className: (row) => row.new_ao !== undefined && row.new_ao === 'قرمز' ? 'text-danger' : 'text-primary',
    },
    {
        value: "ابر",
        sortable: false,
        renderer: (row) => row.cloud !== undefined ? row.cloud ? 'بالای ابر' : 'زیر ابر' : 'x',
        className: (row) => row.cloud !== undefined ? handleClassRederer(row.cloud, 0) : '',
    },
    {
        value: "شاخص",
        sortable: false,
        renderer: (row) => row.stock_total_index !== undefined ? humanizeNumber(row.stock_total_index) : 'x'
    },
    {
        value: "تغییر شاخص",
        sortable: false,
        renderer: (row) => row.stock_change_percent !== undefined ? row.stock_change_percent : 'x',
        className: (row) => row.stock_change_percent !== undefined ? handleClassRederer(row.stock_change_percent, 0) : '',
    },
    {
        value: "هموزن",
        sortable: false,
        renderer: (row) => row.types !== undefined && row.types.totalequel_weithed ? humanizeNumber(row.types.totalequel_weithed.value) : 'x'
    },
    {
        value: "تغییر هموزن",
        sortable: false,
        renderer: (row) => row.types !== undefined && row.types.totalequel_weithed ? fixFloatNumber(row.types.totalequel_weithed.change_percent) : 'x',
        className: (row) => row.types !== undefined && row.types.totalequel_weithed ? handleClassRederer(row.types.totalequel_weithed.change_percent, 0) : '',
    },
    {
        value: "نمره",
        renderer: (row, stock) => row && row.score !== undefined && row.score[stock],
        className: (row, stock) => row && row.score !== undefined && handleClassRederer(row.score[stock], 0),
        direction: 'ltr'
        // className: (row, stock) => row && row.alarm[stock] === 'صعودی' ? 'text-primary' : row.alarm[stock] === 'ریزشی' ? 'text-danger' : null,
    },
    {
        value: "موثر",
        renderer: (row, stock) => row && row.effective_money !== undefined && humanizeNumber(convertCurrency(row.effective_money[stock])),
        className: (row, stock) => row && row.effective_money !== undefined && handleClassRederer(row.effective_money[stock], 0),
        direction: 'ltr'
    },
    {
        value: "5 سطر",
        renderer: (row, stock) => row && row.resultant !== undefined && humanizeNumber(convertCurrency(row.resultant[stock]['buy'] - row.resultant[stock]['sell'])),
        className: (row, stock) => row && row.resultant !== undefined && handleClassRederer(row.resultant[stock]['buy'] - row.resultant[stock]['sell'], 0),
        direction: 'ltr'
    },
    {
        value: "آلارم بازار",
        renderer: (row, stock) => row && row.alarm !== undefined && showAlarm(row, stock),
        className: (row, stock) => row && row.alarm !== undefined && showAlarmClass(row, stock)
    },
    {
        value: "فعالیت",
        renderer: (row, stock) => row && row.alarm !== undefined && showActivity(row, stock),
        className: (row, stock) => row && row.alarm !== undefined && showAlarmClass(row, stock),
    },
]

export { config }